// Label & tombol saat kuota habis.
// Tanpa ctaTitleId/ctaPath, tombol pakai default UpgradeBilling (upgrade paket).
export const getQuotaCta = ({ addonSlug, canBeAddoned }) => {
  if (!addonSlug) {
    return { labelId: 'billing.quota_is_exhausted_add_an_addon' }
  }

  if (canBeAddoned) {
    return {
      labelId: 'billing.quota_is_exhausted_add_an_addon',
      ctaTitleId: 'billing.add_addon',
      ctaPath: `/settings/billing/addon?filter=${addonSlug}`,
    }
  }

  return { labelId: 'billing.quota_is_exhausted_upgrade_plan' }
}
